module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_miyakojima-d6bb0c4b616bfa4bcf2c6249868fcb71.jpg";